export const USER_INPUT_PREVIEW_GENERAL_TABLE_REQUEST = 'USER_INPUT_PREVIEW_GENERAL_TABLE_REQUEST';
export const USER_INPUT_PREVIEW_GENERAL_TABLE_SUCCESS = 'USER_INPUT_PREVIEW_GENERAL_TABLE_SUCCESS';
export const USER_INPUT_PREVIEW_GENERAL_TABLE_FAIL = 'USER_INPUT_PREVIEW_GENERAL_TABLE_FAIL';